import { Query } from '../types';
import {
  getCurrentDestination,
  parseRooms,
  GetterOptions,
  getCurrentSearchParams,
} from './getCurrentSearchParams';
import { getQueryFromSearchParams } from './index';

const fixInvalidQueryParams = (query: Query, options: GetterOptions) => {
  const { startDate, endDate, earlyCheckin, lateCheckout } = getCurrentSearchParams(query, options);

  return {
    ...query,
    ...getQueryFromSearchParams({
      to: getCurrentDestination(query),
      startDate,
      endDate,
      earlyCheckin,
      lateCheckout,
      rooms: parseRooms(query),
    }),
  };
};

export default fixInvalidQueryParams;
